import { Observable } from 'rxjs';
import _ from 'lodash';

import DonationSchedulesApi from 'entities/donationSchedule/api';
import { selectDonationScheduleById } from 'entities/donationSchedule/selectors';
import { selectUser } from 'entities/user/selectors';
import { Privileges } from 'utils/privileges';

import { initSuccessAction, initFailedAction } from './actions';
import { INIT, CANCEL_DONATION_SCHEDULE } from './constants';

const init = (action$, store) =>
  action$.ofType(INIT).exhaustMap((payload) => {
    const actions = [];
    const state = store.getState();
    const user = selectUser(state);

    const donationSchedule = selectDonationScheduleById(state, payload.id);
    if (user?.hasPrivilege(Privileges.DONATION_SCHEDULE_VIEW) && !donationSchedule) {
      actions.push(DonationSchedulesApi.fetchById(payload.id));
    }

    if (actions.length === 0) {
      return Observable.of(initSuccessAction());
    }

    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) => [..._.flatten(resultingActions), initSuccessAction()])
      .catch((e) => Observable.of(initFailedAction(e)));
  });

const cancelDonationSchedule = (action$) =>
  action$.ofType(CANCEL_DONATION_SCHEDULE).exhaustMap((payload) =>
    Observable.combineLatest([DonationSchedulesApi.cancelDonationSchedule(payload.id)])
      .mergeMap((resultingActions) => [..._.flatten(resultingActions), initSuccessAction()])
      .catch((e) => Observable.of(initFailedAction(e)))
  );

export default [init, cancelDonationSchedule];
